import React from 'react'
import Resx from '@/components/Resx'
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, ModalFooter, Button } from 'reactstrap'
import { localized } from '@/decorators/localized'
import Icon from '@/components/Icon'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { NumericInput } from '@/components/inputs'

@localized()
class CreateReportingYearDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.minimumYear = new Date().getFullYear()
    this.state = { year: this.minimumYear }
  }
  handleKeyDown (evt) {
    if (evt.keyCode === 13) { evt.preventDefault() }
  }
  saveChanges () {
    this.props.onSaveChanges(this.state.year)
  }
  render () {
    const { localize } = this.props
    return (
      <ValidationBoundary>
        <Modal isOpen={this.props.isOpen}>
          <ModalHeader toggle={() => this.props.onCancel()}>{localize('Reporting.CreateNewYearTitle')}</ModalHeader>

          <ModalBody>
            <Form>
              <FormGroup>
                <Label for='year'><Resx name='Reporting.Year' /></Label>
                <Validator name='year' value={this.state.year} required max={2100} min={this.minimumYear}>
                  <NumericInput name='year' id='year' integerOnly value={this.state.year} onKeyDown={evt => this.handleKeyDown(evt)} onChange={value => this.setState({ year: value })} />
                </Validator>
              </FormGroup>
            </Form>
          </ModalBody>

          <ModalFooter>
            <ValidationState render={({ isValid }) =>
              <Button color='success' disabled={!isValid} onClick={() => this.saveChanges()}><Icon name='save' /> <span>{localize('Reporting.Create')}</span></Button>
            } />
          </ModalFooter>
        </Modal>
      </ValidationBoundary>
    )
  }
}

export default CreateReportingYearDialog



// WEBPACK FOOTER //
// ./src/internal-app/pages/years/CreateReportingYearDialog.js